import { useState, useEffect } from "react"
import HCRender from "../hc-render"

const HomeLayout = ({
  isHomePage,
  breadcrumbs = [],
  refreshKey,
  currentLanguage,
  searchState,
  onSearchResultSelect,
  rootCategoriesData,
  onArticleSelect,
  onCategorySelect,
  expandedCategories,
  currentPath,
  isLoading,
  error,
  selectedContent,
  contentType,
  onFeedback,
  navigateTo,
}) => {
  const Header = HCRender.getFragment("Header")
  const BreadcrumbsSection = HCRender.getFragment("BreadcrumbsSection")
  const HomePage = HCRender.getFragment("HomePage")
  const ContentPage = HCRender.getFragment("ContentPage")

  const [isClient, setIsClient] = useState(false)
  useEffect(() => { setIsClient(true) }, [])

  const shouldShowBreadcrumbs = isClient && !isHomePage && breadcrumbs.length > 0

  return (
    <div
      className="relative w-full flex flex-col bg-gradient_hc_home rounded-b-[50px] md:rounded-b-[100px] overflow-x-hidden px-4 md:px-px1_l xl:px-px1_xl"
      key={`help-center-${refreshKey}-${currentLanguage}`}
    >
      {Header && (
        <Header
          searchState={searchState}
          onSearchResultSelect={onSearchResultSelect}
        />
      )}

      {shouldShowBreadcrumbs && BreadcrumbsSection && (
        <BreadcrumbsSection items={breadcrumbs} />
      )}

      <div className="w-full max-w-w2_xl flex-grow flex mx-auto">
        {isHomePage ? (
          HomePage && <HomePage />
        ) : (
          ContentPage && (
            <ContentPage
              rootCategoriesData={rootCategoriesData}
              onArticleSelect={onArticleSelect}
              onCategorySelect={onCategorySelect}
              expandedCategories={expandedCategories}
              currentPath={currentPath}
              isLoading={isLoading}
              error={error}
              selectedContent={selectedContent}
              contentType={contentType}
              onFeedback={onFeedback}
              navigateTo={navigateTo}
            />
          )
        )}
      </div>
    </div>
  )
}

export default HomeLayout
